export async function GetAndUpdateUser(userId, tratamientoId, remove) {
	    const authToken = sessionStorage.getItem( 'token' );

        try {
            const getUser = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/users/${userId}`, {
                method: 'GET',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                },
            } );
            const userData = await getUser.json();

            let actualValues = userData.meta.tratamientos;
            let newValues = [];
            if (remove !== true) {
                if ( actualValues.length === 0 ) {
                    newValues.push( tratamientoId );
                    console.log("Primer tratamiento en paciente");
                } else if(actualValues.indexOf(tratamientoId) === -1) {
                    actualValues.push( tratamientoId );
                    newValues = actualValues;
                    console.log("Añadido a listado de tratamientos");
                } else {
                    newValues = actualValues;
                    console.log("Tratamiento existente");
                }
            } else {
                newValues = actualValues.filter(valor => valor !== tratamientoId);
            }

            console.log(newValues)

            let treatmentStringList = newValues.toString();
                console.log(treatmentStringList)

            const getTratamientos = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/tratamiento?include=${treatmentStringList}`, {
                method: 'GET',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                },
            } );
            const tratamientosData = await getTratamientos.json();

            // console.log(tratamientosData);
            // Get all tratamientos from this paciente

            let especialistas =[];

            {tratamientosData?.map((tratamiento) => (
                especialistas = especialistas.concat(tratamiento.meta?.especialistas)
            ))}

            // Generate an array with values from specialistas
            // console.log(especialistas)

            let especialistasString = especialistas.join(",");

            // Join this array into a string coma-separated

            // console.log(especialistasString)

            especialistasString = Array.from(new Set(especialistasString.split(','))).toString();

            // remove duplicate results

            // console.log(especialistasString)

            const formDataUser = {
                meta: {
                    tratamientos: newValues,
                    especialistas: especialistasString,
                }
            };
            const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/users/${userId}`, {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,

                },
                body: JSON.stringify(formDataUser),
            } );
            const values = await response.json();
            return values;

        } catch (error) {
            console.error(error);
        }

}